export default "__VITE_ASSET__f8ef6897__"